import './FormSection.css'
import PlanForm from './PlanForm'

export default function FormSection() {
  return (
    <>
     <div className='form-section'>
        <div className='container'>
            <div className='form-wrapper'>
                <div className='form-text-section'>
                    <h1>Your Next Team Celebration is One Click Away</h1>
                </div>
                <div className='form-content-section'>
                    <PlanForm/>
                </div>
            </div>
        </div>
     </div>
    </>
  )
}
